<template>
  <div>
    <sc-modal
      v-for="(notification, index) in notifications"
      :key="index"
      :active.sync="!notification.isReaded"
      :canCancel="false">
      <sc-modal-card>
        <template slot="title">
          <h2
            class="modal-card-title notification-title"
            :class="`notification-title--${getClassPerType(notification.type)}`">{{ notification.title }}</h2>
        </template>

        <template slot="body">
          <section class="content">
            <p v-html="notification.message"></p>
            <p>
              <a
                :href="notification.link"
                target="_blank"
                class="button is-primary">
                Visualizar nota fiscal
              </a>
            </p>
          </section>
        </template>

        <template slot="footer">
          <sc-button
            v-if="notification.type === types.INFO"
            type="button"
            text="Ok, obrigado!"
            :loading="loading"
            :theme="getClassPerType(notification.type)"
            @click="closeNotification(notification)" />

          <sc-button
            v-if="notification.type === types.WARNING"
            type="button"
            text="Estou ciente"
            :loading="loading"
            :theme="getClassPerType(notification.type)"
            @click="closeNotification(notification)" />

          <sc-button
            v-if="notification.type === types.DANGER"
            type="button"
            text="Sair"
            :loading="loading"
            :theme="getClassPerType(notification.type)"
            @click="closeNotification(notification)" />
        </template>
      </sc-modal-card>
    </sc-modal>
  </div>
</template>

<script>
  import { EventBus } from '@intelipost-js/secure-providers';
  import { ScModal, ScModalCard, ScButton } from '@intelipost-js/secure-components';
  import { createNamespacedHelpers } from 'vuex';

  const { mapState, mapMutations, mapActions } = createNamespacedHelpers('notifications');

  export default {
    name: 'sc-notification',
    data() {
      return {
        storageKey: 'notifications',
        types: {
          INFO: 'INFO',
          WARNING: 'WARNING',
          DANGER: 'DANGER',
        },
      };
    },
    computed: {
      ...mapState([
        'loading',
        'notifications',
      ]),
    },
    methods: {
      ...mapActions([
        'getNotifications',
        'confirmReadNotification',
      ]),
      ...mapMutations([
        'setNotifications',
      ]),
      getClassPerType(type) {
        const classes = {
          [this.types.INFO]: 'info',
          [this.types.WARNING]: 'warning',
          [this.types.DANGER]: 'danger',
        };

        return classes[type];
      },
      closeModal(notificationSelected) {
        const notifications = this.notifications
          .map((notification) => {
            if (notification === notificationSelected) {
              Object.assign(notification, {
                isReaded: true,
              });
            }
            return notification;
          });

        this.setNotifications(notifications);
      },
      closeNotification(notificationSelected) {
        const { type } = notificationSelected;

        switch (type) {
          case this.types.DANGER:
            EventBus.$emit('logout');
            break;

          case this.types.WARNING:
            this.confirmReadNotification(notificationSelected)
              .then(() => this.closeModal(notificationSelected));
            break;

          case this.types.INFO:
          default:
            this.closeModal(notificationSelected);
            break;
        }
      },
    },
    beforeMount() {
      this.getNotifications();
    },
    components: {
      ScModal,
      ScModalCard,
      ScButton,
    },
  };
</script>

<style lang="scss">
  @import "~@intelipost-js/secure-ui/src/scss/variables"; //eslint-disable-line

  .notification-title{
    margin: -20px;
    padding: 20px;
    &--info{
      background-color: $info;
      color: $white;
    }
    &--warning{
      background-color: $warning;
      color: $black;
    }
    &--danger{
      background-color: $danger;
      color: $white;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/sc-notification/ScNotification.vue